var React = require('react');

function RightArrowInline (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"15.561,0 14.146,1.414 42.439,29.707 14.146,58 15.561,59.414 45.268,29.707 "}));
}

RightArrowInline.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 59.414 59.414","style":{"enableBackground":"new 0 0 59.414 59.414"},"xmlSpace":"preserve"};

module.exports = RightArrowInline;

RightArrowInline.default = RightArrowInline;
